export const SERVER_URL =
  process.env.isDev == "TRUE"
    ? "http://localhost:80/"
    : "https://youtubemyspotify.co.uk/";
